export const recipientTypeValues = ['gp', 'psychiatrist', 'school', 'familyMember', 'other', 'referringOrg'] as const;
export type RecipientType = (typeof recipientTypeValues)[number];

export interface ConsentRecipient {
    recipientType: RecipientType;
    recipientEmail?: string | null;
    recipientName?: string | null;
    organisationId?: number;
}

export interface CreateParentConsentPayload {
    partnerCamhsChildId: number;
    consents: ConsentRecipient[];
}
